import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, CopyBox } from 'src/common';
import styles from './index.module.scss';
import { useActiveInboxState } from 'src/models/callOffs/hooks';
import CallOffsTitle from '../CallOffsTitle';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/pro-light-svg-icons';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';

interface IProps {}
export const CallOffsEmpty: FC<IProps> = () => {
  const { t, i18n } = useTranslation();
  const [activeInbox] = useActiveInboxState();
  const isKnowledgeBankFeature = useFeatureFlag(FeatureFlag.KnowledgeBank);

  return (
    <>
      <CallOffsTitle />
      {activeInbox && (
        <div className={styles.content}>
          <Spinner className={styles.loading} />
          <h3 className={styles.title}>{t('CallOffs.waitingEmailsTitle')}</h3>
          <p className={styles.desc}>{t('CallOffs.generatedInboxDesc')}</p>
          <p className={styles.desc}>{t('CallOffs.waitingEmailsDesc')}</p>
          {isKnowledgeBankFeature && (
            <a
              href={`${import.meta.env.VITE_HELPDOCS_DOMAIN}${
                i18n.language
              }/article/wtpyp81lu8-vidarebefordra-avropsf-rfr-gningar`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              <FontAwesomeIcon icon={faBookOpen} />
              <span>{t('CallOffs.learnMoreAboutEmails')}</span>
            </a>
          )}
          <p className={classNames(styles.note, styles.desc)}>{t('CallOffs.forwardInboxNote')}</p>
          <CopyBox value={activeInbox.emailAddress} />
        </div>
      )}
    </>
  );
};

export default CallOffsEmpty;
